<svg width="100%" height="100%" viewBox="0 0 307 307" version="1.1" xmlns="http://www.w3.org/2000/svg"
     xml:space="preserve"
     style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;" [ngClass]="!disabled ? 'add-new-btn cursor-pointer' : 'add-new-btn cursor-forbidden'"
     [matTooltip]="'Video is loading.'" [matTooltipDisabled]="!disabled">
    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
        <circle id="Ellipse_46" cx="36.813" cy="36.813" r="36.813" [style.fill]="!disabled ? color : greyColor"/>
      <g id="Icon_feather-plus" transform="matrix(1,0,0,1,22.205,22.205)">
            <g id="Path_162" transform="matrix(1,0,0,1,-3.392,-7.5)">
                <path d="M18,7.5L18,36.716" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:5px;"/>
            </g>
        <g id="Path_163" transform="matrix(1,0,0,1,-7.5,-3.392)">
                <path d="M7.5,18L36.716,18" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:5px;"/>
            </g>
        </g>
    </g>
</svg>
